import { FunctionComponent } from 'react'

import { Navigate } from 'react-router-dom'

import { Spinner } from '@fairhq/common'
import { Layout } from 'layout/Layout'

import { useGetStrategyQuery } from 'store/strategy/strategyApi'

import { CommittedStrategy } from './CommittedStrategy'

export const Strategy: FunctionComponent = () => {
  const { data: strategy, isSuccess, isFetching } = useGetStrategyQuery()

  return (
    <Layout dark>
      {isFetching && <Spinner center />}
      {isSuccess && strategy?.committedAt && <CommittedStrategy />}
      {isSuccess && !strategy?.committedAt && <Navigate to="/404" />}
    </Layout>
  )
}
